import { campuses } from '../../content/campuses.js';
import { Icon } from '../Icon/Icon.js';

export function CampusStrip() {
  return (
    <section
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: 'clamp(28px,4vw,40px) clamp(18px,5vw,64px) 0',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '10px',
        }}
      >
        {campuses.items.map((campus) =>
          campus.placeholder ? (
            <div
              key={campus.label}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                borderRadius: '999px',
                padding: '9px 16px',
                border: '1px dashed var(--edge)',
                font: "700 12.5px/1 'Plus Jakarta Sans',sans-serif",
                color: 'var(--faint)',
              }}
            >
              <Icon name="more_horiz" style={{ fontSize: '14px', color: 'var(--faint)' }} />
              {campus.label}
            </div>
          ) : (
            <div
              key={campus.label}
              class="glass-hover"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                borderRadius: '999px',
                padding: '9px 16px',
                font: "700 12.5px/1 'Plus Jakarta Sans',sans-serif",
                color: 'var(--ink)',
              }}
            >
              <Icon name="location_on" style={{ fontSize: '14px', color: 'var(--yellow)' }} />
              {campus.label}
            </div>
          ),
        )}
      </div>
    </section>
  );
}
